import React from "react";
import {
  Button,
  Column,
  DataTable,
  DataTableSkeleton,
  Grid,
  Pagination,
  Select,
  SelectItem,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableExpandHeader,
  TableHeader,
  TableBody,
  TableExpandRow,
  TableCell,
  TableExpandedRow,
  TableSelectAll,
  TableSelectRow,
  TableToolbar,
  // TableToolbarAction,
  TableToolbarContent,
  TableToolbarSearch,
  // TableToolbarMenu,
} from "@carbon/react";
import { Add, ArrowUpRight } from "@carbon/react/icons";

import { quickTableConfig } from "../../configs";
import { filterConstants } from "../../constants";
import calendarIcon from "../../assets/icons/calendar.svg";

export const View = ({
  // identity
  id,

  // title
  tableTitle = "",
  tableSubtitle = "",

  // data
  data,
  headers,
  isLoading,
  itemCount,

  // styling
  tableClassName = "",

  // render details
  renderDetail,

  // pagination
  currentPageSize,
  availablePageSizes = quickTableConfig.availablePageSizes,
  setCurrentPage,
  setCurrentPageSize,
  setFirstRowIndex,

  // filtering
  transactionPeriod,
  onTransactionPeriodChange,
  onToolbarSearchInputChange,
  defaultSearchValue,
  toolbarTabs,

  // extra buttons
  extraButtons,
  onExport,
  onCreateNew,
  createNewButtonText,
}) => {
  const action = (params) => {
    // console.log("table action called with params: ", params);
  };

  if (isLoading) {
    return (
      <Grid className={`${tableClassName}`}>
        <Column lg={16} md={8} sm={4} className="repo-page__r1">
          <DataTableSkeleton
            columnCount={headers.length /* + 1*/}
            rowCount={10}
            headers={[
              // renderDetail && {
              //   key: "expanderPlaceholder",
              //   header: "",
              // },
              // {
              //   key: "rowSelectionPlaceholder",
              //   header: "",
              // },
              ...headers,
            ]}
            showHeader={false}
          />
        </Column>
      </Grid>
    );
  }

  return (
    <DataTable
      rows={data}
      headers={headers}
      isSortable
      render={({
        rows,
        headers,
        getHeaderProps,
        getRowProps,
        getSelectionProps,
        getTableProps,
      }) => {
        // perform actions before render

        return (
          <TableContainer
            id={`${id}_container`}
            title={tableTitle}
            description={tableSubtitle}
          >
            <TableToolbar>
              <TableToolbarContent>
                {toolbarTabs && toolbarTabs}

                {/* pass in `onInputChange` change here to make filtering work */}
                <TableToolbarSearch
                  defaultExpanded
                  defaultValue={defaultSearchValue}
                  onChange={(evt) =>
                    evt && onToolbarSearchInputChange(evt.target.value)
                  }
                />

                <span
                  className="filter-text centered"
                  style={{
                    // centered not working
                    margin: "auto 10px",
                  }}
                >
                  Filter:
                </span>

                {/* <div>
                  <Select
                    id="select-transaction-period"
                    className="select-transaction-period"
                    defaultValue={transactionPeriod}
                    labelText=""
                    size="sm"
                    onChange={(evt) =>
                      onTransactionPeriodChange(evt.target.value)
                    }
                  >
                    {filterConstants.transactionPeriods.map((tp) => (
                      <SelectItem
                        key={tp.value}
                        value={tp.value}
                        text={`Last ${tp.key}`}
                      />
                    ))}
                  </Select>

                  <div className="transaction-period--display">
                    <img
                      src={calendarIcon}
                      alt="selected period"
                      className="transaction-period--icon"
                    />
                    <span>Jun 24 - Aug 23</span>
                  </div>
                </div> */}

                {extraButtons && extraButtons}

                {!onExport ? (
                  <></>
                ) : (
                  <Button
                    onClick={onExport}
                    size="sm"
                    kind="tertiary"
                    className="switchapp-themed export-button"
                    iconDescription="Export"
                  >
                    <ArrowUpRight size={18} className="export-button--icon" />
                    Export
                  </Button>
                )}

                {!onCreateNew ? (
                  <></>
                ) : (
                  <Button
                    onClick={onCreateNew}
                    size="sm"
                    className="switchapp-themed create-new-button"
                    iconDescription="Create a new payment"
                  >
                    <Add size={18} />
                    {createNewButtonText || "Create a payment"}
                  </Button>
                )}
              </TableToolbarContent>
            </TableToolbar>

            <Table id={id} {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {renderDetail && <TableExpandHeader />}
                  <TableSelectAll {...getSelectionProps()} />
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {rows.map((row) => (
                  <React.Fragment key={row.id}>
                    {/* render table cells */}
                    {!renderDetail ? (
                      <TableRow
                        key={row.id}
                        {...getRowProps({ row })}
                        onClick={(evt) => {
                          // action("TableRow onClick")(evt);
                        }}
                      >
                        <TableSelectRow
                          {...getSelectionProps({ row })}
                          onSelect={(evt) => {
                            // action("TableSelectRow onSelect")(evt);
                            getSelectionProps({ row }).onSelect(evt);
                          }}
                        />
                        {row.cells.map((cell) => (
                          <TableCell key={cell.id}>{cell.value}</TableCell>
                        ))}
                      </TableRow>
                    ) : (
                      // with row detail expansion
                      <TableExpandRow {...getRowProps({ row })}>
                        <TableSelectRow
                          {...getSelectionProps({ row })}
                          onSelect={(evt) => {
                            // action('TableSelectRow onSelect')(evt);
                            getSelectionProps({ row }).onSelect(evt);
                          }}
                        />

                        {row.cells.map((cell) => (
                          <TableCell key={cell.id}>{cell.value}</TableCell>
                        ))}
                      </TableExpandRow>
                    )}

                    {/* with master detail */}
                    {!renderDetail ? (
                      <></>
                    ) : (
                      <TableExpandedRow colSpan={headers.length + 2}>
                        {renderDetail(row)}
                      </TableExpandedRow>
                    )}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>

            <Pagination
              totalItems={itemCount ? itemCount : rows.length}
              backwardText="Previous"
              forwardText="Next"
              pageSize={currentPageSize}
              pageSizes={availablePageSizes}
              itemsPerPageText="Items per page"
              onChange={({ page, pageSize }) => {
                console.log(
                  "page in QuickTable > Pagination > onChange: ",
                  page
                );

                setCurrentPage(page);
                setFirstRowIndex(pageSize * (page - 1));

                if (pageSize !== currentPageSize) {
                  setCurrentPageSize(pageSize);
                }
              }}
              size="lg"
            />
          </TableContainer>
        );
      }}
    />
  );
};
